



























































import {Component, Prop, Vue} from "vue-property-decorator";
import EmploymentService from "@/services/EmploymentService";
import {EmploymentFilter} from "@/dto/payroll/Filters";
import Workspaces from "@/state/Workspaces";
import {
	TimeSheetFilter,
	TimeSheetPayPeriod,
} from "@/dto/payroll/timesheet/TimesheetPayloads";
import {processError} from "@/utils/ComponentUtils";
import Application from "@/state/Application";
import {EmploymentStatus} from "@/components/payroll/business/employments/contractors/Contractor";
import {namespace} from "vuex-class";
import {CounterpartyType} from "@/constants/CounterpartyType";
import moment from "moment-timezone";
import {v4 as uuidv4} from "uuid";
import TimeSheetPeriod from "@/components/payroll/timesheet/TimeSheetPeriod.vue";
import TimesheetService from "@/services/payroll/TimesheetService";
import BTPortalCollapse from "@/components/common/BTPortalCollapse.vue";
import PortalRadio from "@/components/v2/common/PortalRadio.vue";
import SelectOption from "@/components/common/SelectOption";
import {PolicySignature} from "@/dto/payroll/policies/PTOPolicyDTO";
import PolicyService from "@/services/payroll/PolicyService";
import TimesheetRequest from "@/components/payroll/timesheet/TimesheetRequest.vue";
import BusinessCalendarTimesheet from "@/components/payroll/timesheet/BusinessCalendarTimesheet.vue";
import {IEmployment} from "@/dto/payroll/IEmployment";
import {ProjectDTO, ProjectDTOWithHolder} from "@/dto/payroll/ProjectDTOs";
import CompanyService from "@/services/CompanyService";

type Mode = "PROJECT" | "TIMESHEET"

const AppModule = namespace("App");

export interface ExistPolicies {
	pto: boolean,
	slp: boolean
}

@Component(
	{
		computed: {
			SelectOption() {
				return SelectOption
			},
		},
		components: {
			BusinessCalendarTimesheet,
			TimesheetRequest,
			PortalRadio,
			BTPortalCollapse,
			TimeSheetPeriod
		}
	}
)
export default class IndividualTimesheet extends Vue{

	private id = uuidv4()

	private mode: Mode = "PROJECT"

	@Prop()
	private timeFormat!: string
	@Prop({default: [], required: false})
	private employmentsOfProject!: IEmployment[]

	private project: number | null = null

	private employments: Array<IEmployment> = [];
	private projects: Array<ProjectDTOWithHolder> = [];

	private selectedProject: ProjectDTOWithHolder | null = null

	private selectedEmployee: IEmployment | null = null

	private timesheetPeriods: Array<TimeSheetPayPeriod> = [];

	private employmentFilter: EmploymentFilter = new EmploymentFilter(
		{
			types: ["STAFF", "FOREIGN"],
			contractorType: CounterpartyType.PERSON,
			detailsId: Workspaces.getCurrent.id,
			status: [EmploymentStatus.ACTIVE, EmploymentStatus.PENDING_FOR_DOCUMENTS, EmploymentStatus.NEW]
		}
	)

	private timesheetFilter = new TimeSheetFilter(
		{
			startDate: moment().set({weekday: 0}).format("YYYY-MM-DD"),
			endDate: moment().set({weekday: 6}).format("YYYY-MM-DD"),
			employmentsId: this.employments.map(it => it.id) as number[],
			projectId: this.project
		}
	)

	closeTimesheetProject() {
		this.timesheetPeriods = [];
		this.mode = "PROJECT";
		this.project = null;
		this.selectedProject = null;
	}

	public created(): void {
		Application.startLoading()
			.then(this.loadEmployments)
			.then(this.loadAllManagedProjects)
			.finally(Application.stopLoading)
	}

	private loadEmployments() {
		return EmploymentService.getAllByFilter(this.employmentFilter).then(
			res => {
				this.employments = res.data;
					this.projects = this.employments.flatMap(employment => employment.projects.map(it => new ProjectDTOWithHolder(employment, it)))
			},
			err => processError(err, this)
		)
	}

	get projectsByCompanyName(): Array<{ companyName: string, projects: ProjectDTOWithHolder[] }> {
		const grouped = new Map<string, ProjectDTOWithHolder[]>();

		this.employments.forEach((employment: IEmployment) => {
			grouped.set(employment.employer.name, [])
		});

		this.projects.filter(it => !it.manager || (it.employments.length > 0 && it.manager)).forEach((project: ProjectDTOWithHolder) => {
			const companyName = project.company.name;
			if (!grouped.has(companyName)) {
				grouped.set(companyName, []);
			}
			grouped.get(companyName)?.push(project);
		});

		return Array.from(grouped.entries()).map(([companyName, projects]) => ({
			companyName,
			projects
		}));
	}

	groupProjectsByCompanyId(arr: ProjectDTOWithHolder[]): Array<{ companyId: number, projects: ProjectDTOWithHolder[] }> {
		const grouped = new Map<number, ProjectDTOWithHolder[]>();

		arr.forEach((project: ProjectDTOWithHolder) => {
			const companyId = project.company.id;
			if (!grouped.has(companyId)) {
				grouped.set(companyId, []);
			}
			grouped.get(companyId)?.push(project);
		});

		return Array.from(grouped.entries()).map(([companyId, projects]) => ({
			companyId,
			projects
		}));
	}

	private loadAllManagedProjects(): Promise<void> {
		const managedProjects = this.projects.filter(it => it.manager);
		if (managedProjects.length == 0) return Promise.resolve()
		return Promise.all(
			this.groupProjectsByCompanyId(managedProjects)
				.filter(pair => pair.projects.length > 0)
				.map(pair => this.loadManagedProjects(pair.companyId, pair.projects))
		).then(() => Promise.resolve())
	}

	private loadManagedProjects(companyId: number, projects: ProjectDTO[]) {
		return CompanyService.getProjectsByCompanyId(companyId, projects.map(it => it.id)).then(
			res => res.data.forEach((project: ProjectDTO) => projects.find(it => it.id === project.id)!.employments = project.employments),
			err => processError(err, this)
		)
	}

	private async loadTimesheetRecords() {
		Application.startLoading()
		this.timesheetFilter.startDate = moment().set({weekday: 0}).format("YYYY-MM-DD");
		this.timesheetFilter.endDate = moment().set({weekday: 6}).format("YYYY-MM-DD")
		TimesheetService.getPayPeriod(this.timesheetFilter).then(
			res => {
				this.timesheetPeriods = res.data
				this.mode = "TIMESHEET"
			},
			err => processError(err, this)
		).finally(Application.stopLoading)
	}

	private selectProject(project: ProjectDTOWithHolder) {
		this.timesheetFilter.employmentsId = [project.holder.id!]
		this.timesheetFilter.employerId = project.holder.employer.id
		this.timesheetFilter.projectId = project.id
		this.project = project.id;
		this.selectedProject = project
		this.selectedEmployee = project.holder
		this.loadTimesheetRecords()
	}

	private selectProjectWithEmployee(project: ProjectDTOWithHolder, employee: IEmployment) {
		this.timesheetFilter.employmentsId = [employee.id!]
		this.timesheetFilter.employerId = employee.employer.id
		this.timesheetFilter.projectId = project.id
		this.project = project.id;
		this.selectedProject = project
		this.selectedEmployee = project.holder
		this.loadTimesheetRecords()
	}

	private selectAllProjects(companyName: string) {
		const employee = this.employments.find(it => it.employer.name === companyName)!
		this.timesheetFilter.employmentsId = [employee.id!]
		this.timesheetFilter.employerId = employee.employer.id
		this.timesheetFilter.projectId = null
		this.selectedEmployee = employee
		this.selectedProject = null
		this.project = null;
		this.loadTimesheetRecords()
	}
}

